export const MenuData = [
  {
    title: "Home",
    url: "/",
    cName: "nav-links",
    icon: "fa-solid fa-house-user",
  },
  {
    title: "About",
    url: "/about",
    cName: "nav-links",
    icon: "fa-solid fa-circle-user",
  },
  {
    title: "Gallery",
    url: "/gallery",
    cName: "nav-links",
    icon: "fa-solid fa-gallery-thumbnails",
  },
  {
    title: "Contact",
    url: "/contact",
    cName: "nav-links",
    icon: "fa-solid fa-address-book",
  },

  {
    title: "Achievements",
    url: "/achievements",
    cName: "nav-links",
    icon: "fa-solid fa-trophy",
  },
];
